module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('texas-map', {
    attrs: {
      "mapFile": "tx.counties.json",
      "dataFile": "tx_load.csv",
      "res": "Meredith",
      "resFile": "texas_resv.json",
      "whichState": "TX"
    }
  }), _vm._v(" "), _c('drought-map', {
    attrs: {
      "mapFile": "tx.counties.json",
      "centersFile": "tx_centers.json",
      "dataFile": "tx-counties.csv"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-195e596c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Texas.vue
// module id = 365
// module chunks = 1